import { render, staticRenderFns } from "./StockTrfPrintDetails_Details.vue?vue&type=template&id=7c8b073a&"
import script from "./StockTrfPrintDetails_Details.vue?vue&type=script&lang=js&"
export * from "./StockTrfPrintDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports